module.exports = __webpack_public_path__ + "img/house_pv_panel_idle_online.ab559413.png";